<!-- Info. Msg - Ship IMO - Valid Rebates -->
<!-- <div id="divIMOValidRebate" *ngIf="isShipIMOHasValidRebate" class="bs-callout bs-callout-info">
    <h4>Info.</h4>
    <p>This Ship with IMO No. [{{rebateRequestForm?.controls['TabOne']?.controls['IMONo']?.value}}] has a Valid Rebate Request Submitted.</p>
    <p>Request No. [{{validRebateRequest?.BaseRequest?.RequestNumber}}]</p>
</div> -->

<!-- Disable Caching -->
<!-- <meta http-equiv="cache-control" content="no-cache, must-revalidate, post-check=0, pre-check=0">
<meta http-equiv="expires" content="0">
<meta http-equiv="pragma" content="no-cache"> -->
<!-- Cloned Request -->

<!-- Form Title [Primary] -->
<h2 *ngIf="!editModeAdmin" class="sectionTitle">Rebate Request</h2>
<div [class.read-only-content]="formMode == 3">
  <!-- Request Details Summary -->
  <div *ngIf="(formMode == 2 || formMode == 3) && !isFormValid && !isCloneComponent">
    <app-request-details [baseRequest]="rebateRequestLoaded.BaseRequest"></app-request-details>
    <div *ngIf="rebateRequestLoaded.RebateFileNumber != null" class="bs-callout bs-callout-info">
      <h4>Rebate File Number</h4>
      <p>[{{rebateRequestLoaded.RebateFileNumber}}]</p>
    </div>
  </div>
  <!-- Internal Status -->
  <!-- <div *ngIf="true && formMode != 1 && !isFormValid" class="bs-callout bs-callout-info"> -->
  <div *ngIf="currentUser?.IsAdmin && formMode != 1 && !isFormValid" class="bs-callout bs-callout-info">
    <h4>Internal status</h4>
    <p>{{rebateRequestLoaded?.Status1?.StatusEN}}</p>
  </div>
  <!-- Rejection Reason -->
  <div *ngIf="rebateRequestLoaded?.LongHaulRequestEconomicCommittee?.DecisionId == 3 && !isFormValid"
    class="bs-callout bs-callout-danger">
    <h4>Rejection Reason</h4>
    <p>{{rebateRequestLoaded.LongHaulRequestEconomicCommittee.FormulatedDecision}}</p>
  </div>
  <div *ngIf="rebateRequestLoaded.IsSubRequest && !isFormValid" class="bs-callout bs-callout-info">
    <h4>Sub Request</h4>
    <p>Sub Request to Rebate Request No. <a
        (click)="navigateToParentRequestDetails()">[{{rebateRequestLoaded.ParentRequestNumber}}]</a></p>
    <P *ngIf="ParentCreationDateForSubRequest">Created [{{ParentCreationDateForSubRequest | date: 'dd/MM/yyyy H:mm:ss
      '}} {{'GMT+2'}}] </P>
  </div>
  <!-- Measurement Committee Require Modifications Notes -->
  <div *ngIf="isRequireModificationNotesExist && !isFormValid" class="bs-callout bs-callout-info">
    <h4>Required Modifications Notes</h4>
    <p>{{requireModificationNotes}}</p>
  </div>
  <!-- Rebate Request -->
  <div *ngIf="!isFormValid">
    <!-- Form Title [Secondary] -->
    <div *ngIf="editModeAdmin" class="form-container">
      <h4 class="section-title">Rebate Request</h4>
    </div>
    <!-- Form -->
    <form name="rebateRequestForm" [formGroup]="rebateRequestForm">
      <tabset #rebateRequestTabs>
        <!-- Step One -->
        <tab heading="Step One">
          <div class="form-container" formGroupName="TabOne" #tabOne>
            <div class="form-section">
              <h4 class="section-title">Vessel’s Particulars</h4>
              <!-- Vessel Name -->
              <div class="form-group">
                <label for="txtVesselName">Vessel Name</label>
                <span *ngIf="formMode != 3" class="red"> *</span>
                <input type="text" formControlName="VesselName" name="VesselName" id="txtVesselName"
                  class="form-control text-uppercase" />
                <div *ngIf="isTabOneSubmitted && rebateRequestForm?.controls['TabOne']?.controls['VesselName']?.invalid"
                  class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['VesselName']?.errors?.required">This
                    Field is Required</span>
                </div>
                <div *ngIf="rebateRequestForm?.controls['TabOne']?.controls['VesselName']?.invalid" class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['VesselName']?.errors?.pattern">Please
                    Enter a Valid Vessel Name</span>
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['VesselName']?.errors?.maxlength">This
                    Field can be at most 200 characters</span>
                </div>
              </div>
              <!-- Vessel Type -->
              <div class="form-group">
                <label for="ddlVesselTypeId">Vessel Type</label>
                <span *ngIf="formMode != 3" class="red"> *</span>
                <select formControlName="VesselTypeId" class="form-control" id="ddlVesselTypeId" name="VesselType">
                  <option value="" selected>Choose</option>
                  <option *ngFor="let vesselType of vesselTypes" [value]="vesselType?.Id">
                    {{vesselType?.NameEN}}
                  </option>
                </select>
                <div *ngIf="isTabOneSubmitted &&
                  rebateRequestForm?.controls['TabOne']?.controls['VesselTypeId']?.invalid" class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['VesselTypeId']?.errors?.required">This
                    Field is Required</span>
                </div>
              </div>
              <!-- IMO No. -->
              <div class="form-group">
                <label for="txtIMONo">IMO Number</label>
                <span *ngIf="formMode != 3" class="red"> *</span>
                <div class="input-group">
                  <span class="input-group-addon">IMO</span>
                  <!-- <input type="text" formControlName="IMONo" name="IMONo" id="txtIMONo" maxlength="7" class="form-control" (blur)="onIMOBlur()" /> -->
                  <input type="text" formControlName="IMONo" name="IMONo" id="txtIMONo" maxlength="9"
                    class="form-control" (input)="onImoChange($event.target.value)" />
                </div>
                <div *ngIf="showImoWarning" style="color:darkgoldenrod;font-size:14px;">Rebate file No.
                  {{reltatedFileNo}} needs to be closed first to process your new request</div>
                <div *ngIf="isTabOneSubmitted && rebateRequestForm?.controls['TabOne']?.controls['IMONo']?.invalid"
                  class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['IMONo']?.errors?.required">This
                    Field is Required</span>
                </div>
                <div *ngIf="rebateRequestForm?.controls['TabOne']?.controls['IMONo']?.invalid" class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['IMONo']?.errors?.pattern">IMO
                    Number must be (7 to 9) digits</span>
                </div>
              </div>
              <!-- Call Sign -->
              <div class="form-group">
                <label for="txtCallSign">Call Sign</label>
                <span *ngIf="formMode != 3" class="red"> *</span>
                <input type="text" formControlName="CallSign" name="CallSign" id="txtCallSign"
                  class="form-control text-uppercase" />
                <div *ngIf="isTabOneSubmitted && rebateRequestForm?.controls['TabOne']?.controls['CallSign']?.invalid"
                  class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['CallSign']?.errors?.required">This
                    Field is Required</span>
                </div>
                <div *ngIf="rebateRequestForm?.controls['TabOne']?.controls['CallSign']?.invalid" class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['CallSign']?.errors?.pattern">Call
                    Sign allow English Letters and Numbers Only</span>
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['CallSign']?.errors?.maxlength">This
                    Field can be at most 200 characters</span>
                </div>
              </div>
              <!-- DWT -->
              <div class="form-group">
                <label for="txtDWT">DWT</label>
                <span *ngIf="formMode != 3" class="red"> *</span>
                <input type="text" formControlName="DWT" name="DWT" id="txtDWT" maxlength="6" class="form-control" />
                <div *ngIf="isTabOneSubmitted && rebateRequestForm?.controls['TabOne']?.controls['DWT']?.invalid"
                  class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['DWT']?.errors?.required">This
                    Field is Required</span>
                </div>
                <div *ngIf="rebateRequestForm?.controls['TabOne']?.controls['DWT']?.invalid" class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['DWT']?.errors?.pattern">DWT
                    must be (1 to 6) digits</span>
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['DWT']?.errors?.maxlength">This
                    Field can be at most 50 characters</span>
                </div>
              </div>
              <!-- SCNT -->
              <div class="form-group">
                <label for="txtSCNT">Net Tonnage (SCNT)</label>
                <span *ngIf="formMode != 3" class="red"> *</span>
                <input type="text" formControlName="SCNT" name="SCNT" id="txtSCNT" class="form-control" />
                <div *ngIf="isTabOneSubmitted && rebateRequestForm?.controls['TabOne']?.controls['SCNT']?.invalid"
                  class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['SCNT']?.errors?.required">This
                    Field is Required</span>
                </div>
                <div *ngIf="rebateRequestForm?.controls['TabOne']?.controls['SCNT']?.invalid" class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['SCNT']?.errors?.pattern">Net
                    Tonnage (SCNT) must be (1 to 6) digits and allows (1 to 2) Decimals</span>
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['SCNT']?.errors?.maxlength">This
                    Field can be at most 50 characters</span>
                </div>
              </div>
              <!-- Ex Name(s) -->
              <div class="form-group">
                <label for="txtExNames">Ex Name(s)</label>
                <input type="text" formControlName="ExNames" name="ExNames" id="txtExNames" class="form-control" />
              </div>
              <!-- Year Built -->
              <div class="form-group">
                <label for="dpYearBuilt">Year Built</label>
                <span *ngIf="formMode != 3" class="red"> *</span>
                <input #yearBuiltDatepicker="bsDatepicker" bsDatepicker formControlName="YearBuilt"
                  [bsConfig]="{dateInputFormat: 'YYYY', minMode: hour, maxDate: yearBuiltMaxDate}" autocomplete="off"
                  [minDate]='null' (onShown)="onOpenYearBuiltCalendar($event)" id="dpYearBuilt" class="form-control"
                  name="YearBuilt">
                <div *ngIf="isTabOneSubmitted && rebateRequestForm?.controls['TabOne']?.controls['YearBuilt']?.invalid"
                  class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['YearBuilt']?.errors?.required">This
                    Field is Required</span>
                </div>
              </div>
            </div>
            <div class="form-section">
              <h4 class="section-title">Voyage Information</h4>
              <!-- Vessel Condition -->
              <div class="form-group">
                <label>Vessel's Condition</label>
                <span *ngIf="formMode != 3" class="red"> *</span>
                <div>
                  <div class="custom-Radio">
                    <input type="radio" formControlName="IsShipLoaded" id="rbtnIsShipLoadedLaden" value="true"
                      (change)="onVesselConditionChange($event.target.value)" />
                    <label for="rbtnIsShipLoadedLaden">Loaded</label>
                  </div>
                  <div class="custom-Radio">
                    <input type="radio" formControlName="IsShipLoaded" id="rbtnIsShipLoadedBallast" value="false"
                      (change)="onVesselConditionChange($event.target.value)" />
                    <label for="rbtnIsShipLoadedBallast">Ballast</label>
                  </div>
                </div>
                <div *ngIf="isTabOneSubmitted &&
                  rebateRequestForm?.controls['TabOne']?.controls['IsShipLoaded']?.invalid" class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['IsShipLoaded']?.errors?.required">This
                    Field is Required</span>
                </div>
              </div>
              <!-- Cargo Kind -->
              <div *ngIf="rebateRequestForm?.controls['TabOne']?.controls['IsShipLoaded'].value == 'true' && formMode == 1"
                class="form-group">
                <span style="color:rgb(255, 197, 50);font-size:14px;">
                  Providing the detailed and accurate type & quantity of cargo(es) will ensure the prompt response to
                  your rebate request.
                </span>
              </div>
              <div *ngIf="rebateRequestForm?.controls['TabOne']?.controls['IsShipLoaded'].value == 'true'"
                class="form-group">
                <label for="txtCargoKind">Cargo Kind</label>
                <span *ngIf="formMode != 3" class="red"> *</span>
                <input type="text" formControlName="CargoKind" name="CargoKind" id="txtCargoKind"
                  class="form-control" />
                <div *ngIf="isTabOneSubmitted && rebateRequestForm?.controls['TabOne']?.controls['CargoKind']?.invalid"
                  class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['CargoKind']?.errors?.required">This
                    Field is Required</span>
                </div>
                <div *ngIf="rebateRequestForm?.controls['TabOne']?.controls['CargoKind']?.invalid" class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['CargoKind']?.errors?.pattern">Please
                    Enter a Valid Cargo Kind Value</span>
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['CargoKind']?.errors?.maxlength">This
                    Field can be at most 200 characters</span>
                </div>
              </div>
              <!-- Cargo Quantity -->
              <div *ngIf="rebateRequestForm?.controls['TabOne']?.controls['IsShipLoaded'].value == 'true'"
                class="form-group">
                <label for="txtCargoQuantity">Cargo Quantity (Ton)</label>
                <span *ngIf="formMode != 3" class="red"> *</span>
                <input type="text" formControlName="CargoQuantity" name="CargoQuantity" id="txtCargoQuantity"
                  maxlength="6" class="form-control" (input)="onCargoChange($event.target.value)" />
                <div *ngIf="isTabOneSubmitted &&
                  rebateRequestForm?.controls['TabOne']?.controls['CargoQuantity']?.invalid" class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['CargoQuantity']?.errors?.required">This
                    Field is Required</span>
                </div>
                <div *ngIf="showCargoWarning" style="color:rgb(151, 110, 5);font-size:14px;">Cargo
                  Quantity
                  cannot be greater than DWT</div>
                <div *ngIf="rebateRequestForm?.controls['TabOne']?.controls['CargoQuantity']?.invalid" class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['CargoQuantity']?.errors?.pattern">Cargo
                    Quantity must be (1 to 6) digits</span>
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['CargoQuantity']?.errors?.maxlength">This
                    Field can be at most 200 characters</span>
                </div>
              </div>
              <div class="form-group" *ngIf="currentUser?.IsAdmin" >
                <label for="ddlAdminDirectionId">Direction</label>
                <select formControlName="AdminDirectionId" class="form-control" id="ddlAdminDirectionId" name="AdminDirectionId">
                  <option value="" selected>Choose</option>
                  <option *ngFor="let sailDirection of sailDirections" [value]="sailDirection?.Id">
                    {{sailDirection?.Direction}}
                  </option>
                </select>

              </div>
              <div class="form-group" *ngIf="currentUser?.IsAdmin">
                <label for="dpAdminDateOfSailing">Date of Sailing</label>
                <input #dateOfSailingDatepicker="bsDatepicker" bsDatepicker formControlName="AdminDateOfSailing"
                  [bsConfig]="{dateInputFormat: 'DD-MM-YYYY', minMode: hour}" [minDate]='dateOfSailing'
                  autocomplete="off" id="dpAdminDateOfSailing" class="form-control" name="dpAdminDateOfSailing"
                  (ngModelChange)="dateOfSailingChange()">


              </div>

              <!-- ETA -->
              <div class="form-group" *ngIf="currentUser?.IsAdmin">
                <label for="dpETA">Estimated Time of Arrival (ETA)</label>
                <input #ETADatepicker="bsDatepicker" bsDatepicker formControlName="AdminETA"
                  [bsConfig]="{dateInputFormat: 'DD-MM-YYYY', minMode: hour}" autocomplete="off" id="dpETA"
                  class="form-control" name="AdminETA" (ngModelChange)="dateOfSailingChange()">

              </div>


            </div>
            <div class="form-section">
              <h4 class="section-title">Additional Information</h4>



              <!-- Last Transit Date -->
              <div class="form-group">
                <label for="dpLastTransitDate">Last Transit Date</label>
                <input #lastTransitDateDatepicker="bsDatepicker" bsDatepicker formControlName="LastTransitDate"
                  [minDate]='null'
                  [bsConfig]="{dateInputFormat: 'DD-MM-YYYY', minMode: hour, maxDate: yearBuiltMaxDate}"
                  autocomplete="off" id="dpLastTransitDate" class="form-control" name="LastTransitDate">
              </div>
              <!-- LPG LNG Capacity -->
              <div class="form-group">
                <label for="txtLPGLNGCapacity">Capacity in cu. m (for LPG & LNG)</label>
                <!-- <span *ngIf="formMode != 3" class="red"> *</span> -->
                <input type="text" formControlName="LPGLNGCapacity" name="LPGLNGCapacity" id="txtLPGLNGCapacity"
                  maxlength="6" class="form-control" />
                <!-- <div *ngIf="isTabOneSubmitted && rebateRequestForm?.controls['TabOne']?.controls['LPGLNGCapacity']?.invalid" class="red">
                                    <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['LPGLNGCapacity']?.errors?.required">This Field is Required</span>
                                </div> -->
                <div *ngIf="rebateRequestForm?.controls['TabOne']?.controls['LPGLNGCapacity']?.invalid" class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['LPGLNGCapacity']?.errors?.pattern">This
                    Field must be (1 to 6) digits</span>
                  <span
                    *ngIf="rebateRequestForm?.controls['TabOne']?.controls['LPGLNGCapacity']?.errors?.maxlength">This
                    Field can be at most 50 characters</span>
                </div>
              </div>
              <!-- Reefer Capacity -->
              <div class="form-group">
                <label for="txtReeferCapacity">Capacity in cu. ft. (for reefer)</label>
                <!-- <span *ngIf="formMode != 3" class="red"> *</span> -->
                <input type="text" formControlName="ReeferCapacity" name="ReeferCapacity" id="txtReeferCapacity"
                  maxlength="6" class="form-control" />
                <!-- <div *ngIf="isTabOneSubmitted && rebateRequestForm?.controls['TabOne']?.controls['ReeferCapacity']?.invalid" class="red">
                                    <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['ReeferCapacity']?.errors?.required">This Field is Required</span>
                                </div> -->
                <div *ngIf="rebateRequestForm?.controls['TabOne']?.controls['ReeferCapacity']?.invalid" class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['ReeferCapacity']?.errors?.pattern">This
                    Field must be (1 to 6) digits</span>
                  <span
                    *ngIf="rebateRequestForm?.controls['TabOne']?.controls['ReeferCapacity']?.errors?.maxlength">This
                    Field can be at most 50 characters</span>
                </div>
              </div>
              <!-- Max Draught -->
              <div class="form-group">
                <label for="txtMAXDraught">Max Draught (meter)</label>
                <!-- <span *ngIf="formMode != 3" class="red"> *</span> -->
                <input type="text" formControlName="MAXDraught" name="MAXDraught" id="txtMAXDraught" maxlength="5"
                  class="form-control" />
                <!-- <div *ngIf="isTabOneSubmitted && rebateRequestForm?.controls['TabOne']?.controls['MAXDraught']?.invalid" class="red">
                                    <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['MAXDraught']?.errors?.required">This Field is Required</span>
                                </div> -->
                <div *ngIf="rebateRequestForm?.controls['TabOne']?.controls['MAXDraught']?.invalid" class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['MAXDraught']?.errors?.pattern">Max
                    Draught must be (1 to 2) digits and allows (1 to 2) Decimals</span>
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['MAXDraught']?.errors?.maxlength">This
                    Field can be at most 200 characters</span>
                </div>
              </div>
              <!-- TRN. Draught -->
              <div class="form-group">
                <label for="txtTRNDraught">TRN Draught (meter)</label>
                <span *ngIf="formMode != 3" class="red"> *</span>
                <input type="text" formControlName="TRNDraught" name="TRNDraught" id="txtTRNDraught" maxlength="5"
                  class="form-control" />
                <div *ngIf="isTabOneSubmitted && rebateRequestForm?.controls['TabOne']?.controls['TRNDraught']?.invalid"
                  class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['TRNDraught']?.errors?.required">This
                    Field is Required</span>
                </div>
                <div *ngIf="rebateRequestForm?.controls['TabOne']?.controls['TRNDraught']?.invalid" class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['TRNDraught']?.errors?.pattern">TRN
                    Draught must be (1 to 2) digits and allows (1 to 2) Decimals</span>
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['TRNDraught']?.errors?.maxlength">This
                    Field can be at most 200 characters</span>
                </div>
              </div>
              <!-- Beam -->
              <div class="form-group">
                <label for="txtBeam">Beam (meter)</label>
                <span *ngIf="formMode != 3" class="red"> *</span>
                <input type="text" formControlName="Beam" name="Beam" id="txtBeam" maxlength="6" class="form-control" />
                <div *ngIf="isTabOneSubmitted && rebateRequestForm?.controls['TabOne']?.controls['Beam']?.invalid"
                  class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['Beam']?.errors?.required">This
                    Field is Required</span>
                </div>
                <div *ngIf="rebateRequestForm?.controls['TabOne']?.controls['Beam']?.invalid" class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['Beam']?.errors?.pattern">Beam
                    must be (1 to 3) digits and allows (1 to 2) Decimals</span>
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['Beam']?.errors?.maxlength">This
                    Field can be at most 200 characters</span>
                </div>
              </div>
              <!-- Design Speed -->
              <div class="form-group">
                <label for="txtDesignSpeed">Design Speed (NM)</label>
                <!-- <span *ngIf="formMode != 3" class="red"> *</span> -->
                <input type="text" formControlName="DesignSpeed" name="DesignSpeed" id="txtDesignSpeed" maxlength="5"
                  class="form-control" />
                <!-- <div *ngIf="isTabOneSubmitted && rebateRequestForm?.controls['TabOne']?.controls['DesignSpeed']?.invalid" class="red">
                                    <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['DesignSpeed']?.errors?.required">This Field is Required</span>
                                </div> -->
                <div *ngIf="rebateRequestForm?.controls['TabOne']?.controls['DesignSpeed']?.invalid" class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['DesignSpeed']?.errors?.pattern">Design
                    Speed must be (1 to 2) digits and allows (1 to 2) Decimals</span>
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['DesignSpeed']?.errors?.maxlength">This
                    Field can be at most 200 characters</span>
                </div>
              </div>
              <!-- Scrubber Fitted -->
              <div class="form-group">
                <label>Scrubber Fitted</label>
                <span *ngIf="formMode != 3" class="red"> *</span>
                <div>
                  <div class="custom-Radio">
                    <input type="radio" formControlName="IsScrubberFitted" id="rbtnIsScrubberFittedYes" value="true" />
                    <label for="rbtnIsScrubberFittedYes">Yes</label>
                  </div>
                  <div class="custom-Radio">
                    <input type="radio" formControlName="IsScrubberFitted" id="rbtnIsScrubberFittedNo" value="false" />
                    <label for="rbtnIsScrubberFittedNo">No</label>
                  </div>
                </div>
                <div *ngIf="isTabOneSubmitted &&
                  rebateRequestForm?.controls['TabOne']?.controls['IsScrubberFitted']?.invalid" class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['IsScrubberFitted']?.errors?.required">This
                    Field is Required</span>
                </div>
              </div>
              <!-- Main Engine Fuel Type -->
              <div class="form-group">
                <label for="ddlMainEngineFuelId">Main Engine Fuel Type</label>
                <select formControlName="MainEngineFuelId" class="form-control" id="ddlMainEngineFuelId"
                  name="MainEngineFuel" (change)="onMainEngineFuelTypeChange($event.target.value)">
                  <option value="" selected>Choose</option>
                  <option *ngFor="let mainEngineFuel of mainEngineFuels" [value]="mainEngineFuel?.Id">
                    {{mainEngineFuel?.Fuel}}
                  </option>
                  <option value="-1">Other</option>
                </select>
              </div>
              <!-- Other (Main Engine Fuel Type) -->
              <div *ngIf="rebateRequestForm?.controls['TabOne']?.controls['MainEngineFuelId'].value == -1"
                class="form-group">
                <label for="txtOtherMainEngineFuel">Other (Main Engine Fuel Type)</label>
                <span *ngIf="formMode != 3" class="red"> *</span>
                <input type="text" formControlName="OtherMainEngineFuel" name="OtherMainEngineFuel"
                  id="txtOtherMainEngineFuel" class="form-control" />
                <div *ngIf="isTabOneSubmitted &&
                  rebateRequestForm?.controls['TabOne']?.controls['OtherMainEngineFuel']?.invalid" class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['OtherMainEngineFuel']?.errors?.required">This
                    Field is Required</span>
                </div>
              </div>
              <!-- Fuel IFO -->
              <div class="form-group">
                <label for="txtFuelIFO">Design Fuel Consumption (IFO)</label>
                <!-- <span *ngIf="formMode != 3" class="red"> *</span> -->
                <input type="text" formControlName="FuelIFO" name="FuelIFO" id="txtFuelIFO" maxlength="3"
                  class="form-control" />
                <!-- <div *ngIf="isTabOneSubmitted && rebateRequestForm?.controls['TabOne']?.controls['FuelIFO']?.invalid">
                                    <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['FuelIFO']?.errors?.required" class="red">This Field is Required</span>
                                </div> -->
                <div *ngIf="rebateRequestForm?.controls['TabOne']?.controls['FuelIFO']?.invalid" class="red">
                  <!-- <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['FuelIFO']?.errors?.pattern">This Field must be (1 to 3) digits</span> -->
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['FuelIFO']?.errors?.pattern">This
                    Field must be (1 to 2) digits and allows (1) Decimal</span>
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['FuelIFO']?.errors?.maxlength">This
                    Field can be at most 200 characters</span>
                </div>
              </div>
              <!-- Fuel DO -->
              <div class="form-group">
                <label for="txtFuelDO">Design Fuel Consumption (DO)</label>
                <!-- <span *ngIf="formMode != 3" class="red"> *</span> -->
                <input type="text" formControlName="FuelDO" name="FuelDO" id="txtFuelDO" maxlength="3"
                  class="form-control" />
                <!-- <div *ngIf="isTabOneSubmitted && rebateRequestForm?.controls['TabOne']?.controls['FuelDO']?.invalid" class="red">
                                    <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['FuelDO']?.errors?.required">This Field is Required</span>
                                </div> -->
                <div *ngIf="rebateRequestForm?.controls['TabOne']?.controls['FuelDO']?.invalid" class="red">
                  <!-- <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['FuelDO']?.errors?.pattern">This Field must be (1 to 3) digits</span> -->
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['FuelDO']?.errors?.pattern">This
                    Field must be (1 to 2) digits and allows (1) Decimal</span>
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['FuelDO']?.errors?.maxlength">This
                    Field can be at most 200 characters</span>
                </div>
              </div>

              <div class="form-group">
                <label for="RebateNotes">Notes</label>
                <textarea name="RebateNote" id="RebateNote" name="Rebatenote" formControlName="RebateNote"
                  class="form-control"></textarea>
              </div>
              <!-- TPI / TPC -->
              <!-- <div class="form-group">
                                <label for="txtTPITPC">TPI or TPC</label>
                                <span *ngIf="formMode != 3" class="red"> *</span>
                                <input type="text" formControlName="TPITPC" name="TPITPC" id="txtTPITPC" class="form-control" />
                                <div *ngIf="isTabOneSubmitted && rebateRequestForm?.controls['TabOne']?.controls['TPITPC']?.invalid" class="red">
                                    <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['TPITPC']?.errors?.required">This Field is Required</span>
                                </div>
                                <div *ngIf="rebateRequestForm?.controls['TabOne']?.controls['TPITPC']?.invalid" class="red">
                                    <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['TPITPC']?.errors?.maxlength">This Field can be at most 200 characters</span>
                                </div>
                            </div> -->
            </div>
            <div class="form-section">
              <h4 class="section-title">Requester Information</h4>
              <!-- Email -->
              <div class="form-group">
                <label for="lblEmail">Email</label>
                <!-- Read Only -->
                <label class="form-control" name="Email" id="lblEmail">{{currentUserEmail}}</label>
              </div>
              <!-- Operator Name -->
              <div class="form-group">
                <label for="txtOperatorName">Operator Name</label>
                <input type="text" formControlName="OperatorName" name="OperatorName" id="txtOperatorName"
                  class="form-control text-uppercase" />
                <div *ngIf="rebateRequestForm?.controls['TabOne']?.controls['OperatorName']?.invalid" class="red">
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['OperatorName']?.errors?.pattern">Please
                    Enter a Valid Name</span>
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['OperatorName']?.errors?.maxlength">This
                    Field can be at most 200 characters</span>
                </div>
              </div>
              <!-- Operator Email -->
              <div class="form-group">
                <label for="txtOperatorEmail">Operator Email</label>
                <input type="email" formControlName="OperatorEmail" name="OperatorEmail" id="txtOperatorEmail"
                  class="form-control" />
                <div *ngIf="rebateRequestForm?.controls['TabOne']?.controls['OperatorEmail']?.invalid" class="red">
                  <!-- <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['OperatorEmail']?.errors?.email">Please Enter a Valid Email Format</span> -->
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['OperatorEmail']?.errors?.pattern">Please
                    Enter a Valid Email Format</span>
                  <span *ngIf="rebateRequestForm?.controls['TabOne']?.controls['OperatorEmail']?.errors?.maxlength">This
                    Field can be at most 50 characters</span>
                </div>
              </div>
            </div>
          </div>
          <!-- Next -->
          <p *ngIf="formMode != 3" class="btns-holder text-right">
            <button type="button" class="btn SCAcustomBtn" (click)="selectTab(2)">Next</button>
          </p>
        </tab>
        <!-- Step Two -->
        <tab heading="Step Two">
          <!-- Repeated Sections Container -->
          <div formGroupName="TabTwo">
            <!-- Options Grid -->
            <div *ngIf="rebateRequestOptionsArrLength > 1 && isOptionsHeadersEnabled" class="table-responsive">
              <table class="table table-bordered table-striped table-services">
                <thead>
                  <tr>
                    <!-- <th><span>Last Country of Origin</span></th> -->
                    <th><span>Port of Origin - Country of Origin</span></th>
                    <!-- <th><span>First Country of Destination</span></th> -->
                    <th><span>Port of Destination - Country of Destination</span></th>
                    <th *ngIf="formMode != 3"></th>
                    <th *ngIf="formMode != 3"></th>
                    <th *ngIf="formMode == 3"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let optionGridArr of rebateRequestForm.controls['TabTwo'].value['Options']; let o = index;">
                    <!-- Logical Container -->
                    <ng-container *ngIf="(o != rebateRequestOptionsArrLength - 1) && !optionGridArr.IsOptionDeleted">
                      <!-- <td>{{lastCountryOriginsArr[o].Text}}</td> -->
                      <td>{{lastPortOriginsArr[o]?.Text}} - {{lastCountryOriginsArr[o]?.Text}}</td>
                      <!-- <td>{{firstCountryDestinationsArr[o].Text}}</td> -->
                      <td>{{firstPortDestinationsArr[o]?.Text}} - {{firstCountryDestinationsArr[o]?.Text}}
                      </td>
                      <td *ngIf="formMode != 3"><a class="btn" (click)="editOption(o)">Edit</a></td>
                      <td *ngIf="formMode != 3"><a class="btn" Confirmation
                          (confirmationClick)="deleteOption(o)">Delete</a></td>
                      <td *ngIf="formMode == 3"><a class="btn" (click)="detailsOption(o)">Details</a></td>
                    </ng-container>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Voyage(s) Direction -->
            <div class="form-container" #tabTwo>
              <div class="form-section">
                <h4 *ngIf="formMode != 3" class="section-title">Please Select Voyage(s) Direction</h4>
                <h4 *ngIf="formMode == 3" class="section-title">Voyage(s) Direction</h4>
                <!-- Direction -->
                <div class="form-group">
                  <label for="ddlDirectionId">Direction</label>
                  <span *ngIf="formMode != 3 && !isCloneComponent" class="red"> *</span>
                  <select formControlName="DirectionId" class="form-control" id="ddlDirectionId" name="Direction">
                    <option value="" selected>Choose</option>
                    <option *ngFor="let sailDirection of sailDirections" [value]="sailDirection?.Id">
                      {{sailDirection?.Direction}}
                    </option>
                  </select>
                  <div *ngIf="isTabTwoSubmitted &&
                    rebateRequestForm?.controls['TabTwo']?.controls['DirectionId']?.invalid" class="red">
                    <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['DirectionId']?.errors?.required">This
                      Field is Required</span>
                  </div>
                </div>
              </div>
            </div>
            <div formArrayName="Options"
              *ngFor="let option of rebateRequestForm.controls['TabTwo'].get('Options')['controls']; let i = index;">
              <div *ngIf="i === rebateRequestOptionsArrLength - 1 && showOptionDev" [formGroupName]="i">
                <div class="form-container" #options>
                  <!-- Voyage Info. Section -->
                  <div class="form-section">
                    <!-- Options Array Validation Message -->
                    <h5 class="red"  *ngIf="isFormSubmitted && !isOptionsArrValid">Rebate Request should
                      contains One Voyage at least</h5>
                    <h4 class="section-title">Voyage Information</h4>
                    <!-- Actual Speed -->
                    <div class="form-group">
                      <label for="txtActualSpeed">Actual Speed (NM)</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <input type="text" formControlName="ActualSpeed" name="ActualSpeed" id="txtActualSpeed"
                        maxlength="5" class="form-control" />
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.ActualSpeed?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.ActualSpeed?.errors?.required">This
                          Field is Required</span>
                      </div>
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.ActualSpeed?.invalid"
                        class="red">
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.ActualSpeed?.errors?.pattern">Actual
                          Speed must be (1 to 2) digits and allows (1 to 2) Decimals</span>
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.ActualSpeed?.errors?.maxlength">This
                          Field can be at most 50 characters</span>
                      </div>
                    </div>
                    <!-- Last Country of Origin -->
                    <div class="form-group">
                      <label for="ddlLastCountryOriginId">Last Country of Origin</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <select formControlName="LastCountryOriginId" class="form-control"
                        (change)="onLastCountrySelect($event.target.value)" id="ddlLastCountryOriginId"
                        name="LastCountryOrigin">
                        <option value="" selected>Choose</option>
                        <option *ngFor="let country of countries" [value]="country?.Id">
                          {{country?.NameEN}}
                        </option>
                      </select>
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.LastCountryOriginId?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.LastCountryOriginId?.errors?.required">This
                          Field is Required</span>
                      </div>
                    </div>
                    <!-- Last Port of Origin -->
                    <div class="form-group">
                      <label for="ddlLastPortOriginId">Last Port of Origin</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <select formControlName="LastPortOriginId" class="form-control" id="ddlLastPortOriginId"
                        name="LastPortOrigin" (change)="onLastPortSelect($event.target.value)">
                        <option value="" selected>Choose</option>
                        <option *ngFor="let lastPortOrigin of lastPortsOrigin" [value]="lastPortOrigin?.Id">
                          {{lastPortOrigin?.NameEN}}
                        </option>
                        <option value="-1">Other</option>
                      </select>
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.LastPortOriginId?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.LastPortOriginId?.errors?.required">This
                          Field is Required</span>
                      </div>
                    </div>
                    <!-- Other (Last Port of Origin) -->
                    <div
                      *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.LastPortOriginId?.value == -1"
                      class="form-group">
                      <label for="txtOtherLastPortOrigin">Other (Last Port of Origin)</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <input type="text" formControlName="OtherLastPortOrigin" name="OtherLastPortOrigin"
                        id="txtOtherLastPortOrigin" class="form-control" />
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.OtherLastPortOrigin?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.OtherLastPortOrigin?.errors?.required">This
                          Field is Required</span>
                      </div>
                    </div>
                    <!-- First Country of Destination -->
                    <div class="form-group">
                      <label for="ddlFirstCountryDestinationId">First Country of Destination</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <select formControlName="FirstCountryDestinationId" class="form-control"
                        (change)="onFirstCountrySelect($event.target.value)" id="ddlFirstCountryDestinationId"
                        name="FirstCountryDestination">
                        <option value="" selected>Choose</option>
                        <option *ngFor="let country of countries" [value]="country?.Id">
                          {{country?.NameEN}}
                        </option>
                      </select>
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.FirstCountryDestinationId?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.FirstCountryDestinationId?.errors?.required">This
                          Field is Required</span>
                      </div>
                    </div>
                    <!-- First Port of Destination -->
                    <div class="form-group">
                      <label for="ddlFirstPortDestinationId">First Port of Destination</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <select formControlName="FirstPortDestinationId" class="form-control"
                        id="ddlFirstPortDestinationId" name="FirstPortDestination"
                        (change)="onFirstPortSelect($event.target.value)">
                        <option value="" selected>Choose</option>
                        <option *ngFor="let firstPortDestination of firstPortsDestination"
                          [value]="firstPortDestination?.Id">
                          {{firstPortDestination?.NameEN}}
                        </option>
                        <option value="-1">Other</option>
                      </select>
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.FirstPortDestinationId?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.FirstPortDestinationId?.errors?.required">This
                          Field is Required</span>
                      </div>
                    </div>
                    <!-- Other (First Port of Destination) -->
                    <div
                      *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.FirstPortDestinationId?.value == -1"
                      class="form-group">
                      <label for="txtOtherFirstPortDestination">Other (First Port of Destination)</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <input type="text" formControlName="OtherFirstPortDestination" name="OtherFirstPortDestination"
                        id="txtOtherFirstPortDestination" class="form-control" />
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.OtherFirstPortDestination?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.OtherFirstPortDestination?.errors?.required">This
                          Field is Required</span>
                      </div>
                    </div>
                    <!-- Direction -->
                    <!-- <div class="form-group">
                                            <label for="ddlDirectionId">Direction</label>
                                            <span *ngIf="formMode != 3" class="red"> *</span>
                                            <select formControlName="DirectionId" class="form-control" id="ddlDirectionId" name="Direction">
                                                <option value="" selected>Choose</option>
                                                <option *ngFor="let sailDirection of sailDirections" [value]="sailDirection?.Id" >
                                                    {{sailDirection?.Direction}}
                                                </option>
                                            </select>
                                            <div *ngIf="isOptionSubmitted && rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DirectionId?.invalid" class="red">
                                                <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DirectionId?.errors?.required">This Field is Required</span>
                                            </div>
                                        </div> -->
                    <!-- Distance Miles Suez -->
                    <div class="form-group">
                      <label for="txtDistanceMilesSuez">Distance in n. miles via Suez</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <input type="text" formControlName="DistanceMilesSuez" name="DistanceMilesSuez"
                        id="txtDistanceMilesSuez" class="form-control" (ngModelChange)="distanceChange()" />
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DistanceMilesSuez?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DistanceMilesSuez?.errors?.required">This
                          Field is Required</span>
                      </div>
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DistanceMilesSuez?.invalid"
                        class="red">
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DistanceMilesSuez?.errors?.pattern">This
                          Field allows digits only</span>
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DistanceMilesSuez?.errors?.maxlength">This
                          Field can be at most 200 characters</span>
                      </div>
                    </div>
                    <!-- Distance Miles Cape/Panama -->
                    <div class="form-group">
                      <label for="txtDistanceMilesPanama">Distance in n. miles via Cape or Panama</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <input type="text" formControlName="DistanceMilesPanama" name="DistanceMilesPanama"
                        id="txtDistanceMilesPanama" class="form-control" (ngModelChange)="distanceChange()" />
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DistanceMilesPanama?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DistanceMilesPanama?.errors?.required">This
                          Field is Required</span>
                      </div>
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DistanceMilesPanama?.invalid"
                        class="red">
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DistanceMilesPanama?.errors?.pattern">This
                          Field allows digits only</span>
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DistanceMilesPanama?.errors?.maxlength">This
                          Field can be at most 200 characters</span>
                      </div>
                    </div>
                    <!-- Diff. Distance -->
                    <div class="form-group">
                      <label for="txtDiffInDistance">Diff. in Distance</label>
                      <!-- <span *ngIf="formMode != 3" class="red"> *</span> -->
                      <!-- <input type="text" formControlName="DiffInDistance" name="DiffInDistance" id="txtDiffInDistance" class="form-control" [disabled]="true" /> -->
                      <label class="form-control" name="DiffInDistance"
                        id="lblDiffInDistance">{{rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DiffInDistance?.value}}</label>
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DiffInDistance?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DiffInDistance?.errors?.required">This
                          Field is Required</span>
                      </div>
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DiffInDistance?.invalid"
                        class="red">
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DiffInDistance?.errors?.maxlength">This
                          Field can be at most 200 characters</span>
                      </div>
                    </div>
                    <!-- Weather Cond. Days Suez -->
                    <div class="form-group">
                      <label for="txtWhetherSuez">Weather cond. in days via Suez</label>
                      <!-- <span *ngIf="formMode != 3" class="red"> *</span> -->
                      <input type="text" formControlName="WhetherSuez" name="WhetherSuez" id="txtWhetherSuez"
                        class="form-control" />
                      <!-- <div *ngIf="isOptionSubmitted && rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.WhetherSuez?.invalid" class="red">
                                                <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.WhetherSuez?.errors?.required">This Field is Required</span>
                                            </div> -->
                    </div>
                    <!-- Weather cond. Days Cape/Panama -->
                    <div class="form-group">
                      <label for="txtWhetherPanama">Weather cond. in days via Cape or Panama</label>
                      <!-- <span *ngIf="formMode != 3" class="red"> *</span> -->
                      <input type="text" formControlName="WhetherPanama" name="WhetherPanama" id="txtWhetherPanama"
                        class="form-control" />
                      <!-- <div *ngIf="isOptionSubmitted && rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.WhetherPanama?.invalid" class="red">
                                                <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.WhetherPanama?.errors?.required">This Field is Required</span>
                                            </div> -->
                    </div>
                  </div>
                  <!-- Duration Section -->
                  <div class="form-section">
                    <h4 class="section-title">Duration</h4>
                    <!-- Duration Days Suez -->
                    <div class="form-group">
                      <label for="txtDurationSuez">Duration in Days via Suez</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <input type="text" formControlName="DurationSuez" name="DurationSuez" id="txtDurationSuez"
                        class="form-control" />
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DurationSuez?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DurationSuez?.errors?.required">This
                          Field is Required</span>
                      </div>
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DurationSuez?.invalid"
                        class="red">
                        <!-- <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DurationSuez?.errors?.pattern">This Field allows digits only</span> -->
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DurationSuez?.errors?.pattern">This
                          Field allows digits and (1) Decimal</span>
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DurationSuez?.errors?.maxlength">This
                          Field can be at most 50 characters</span>
                      </div>
                    </div>
                    <!-- Duration Days Cape/Panama -->
                    <div class="form-group">
                      <label for="txtDurationPanama">Duration in Days via Cape or Panama</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <input type="text" formControlName="DurationPanama" name="DurationPanama" id="txtDurationPanama"
                        class="form-control" />
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DurationPanama?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DurationPanama?.errors?.required">This
                          Field is Required</span>
                      </div>
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DurationPanama?.invalid"
                        class="red">
                        <!-- <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DurationPanama?.errors?.pattern">This Field allows digits only</span> -->
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DurationPanama?.errors?.pattern">This
                          Field allows digits and (1) Decimal</span>
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DurationPanama?.errors?.maxlength">This
                          Field can be at most 50 characters</span>
                      </div>
                    </div>
                  </div>
                  <!-- Cost Section -->
                  <div class="form-section">
                    <h4 class="section-title">Voyage Cost</h4>
                    <!-- Anti-Piracy Cost Suez -->
                    <div class="form-group">
                      <label for="txtAntiPiracyCostSuez">Anti-Piracy Cost (in details) via Suez ($)</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <input type="text" formControlName="AntiPiracyCostSuez" name="AntiPiracyCostSuez"
                        id="txtAntiPiracyCostSuez" class="form-control" />
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.AntiPiracyCostSuez?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.AntiPiracyCostSuez?.errors?.required">This
                          Field is Required</span>
                      </div>
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.AntiPiracyCostSuez?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.AntiPiracyCostSuez?.errors?.pattern">This
                          Field allows digits only</span>
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.AntiPiracyCostSuez?.errors?.maxlength">This
                          Field can be at most 200 characters</span>
                      </div>
                    </div>
                    <!-- Anti-Piracy Cost Cape -->
                    <div class="form-group">
                      <label for="txtAntiPiracyCostPanama">Anti-Piracy Cost (in details) via Cape ($)</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <input type="text" formControlName="AntiPiracyCostPanama" name="AntiPiracyCostPanama"
                        id="txtAntiPiracyCostPanama" class="form-control" />
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.AntiPiracyCostPanama?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.AntiPiracyCostPanama?.errors?.required">This
                          Field is Required</span>
                      </div>
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.AntiPiracyCostPanama?.invalid"
                        class="red">
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.AntiPiracyCostPanama.errors?.pattern">This
                          Field allows digits only</span>
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.AntiPiracyCostPanama?.errors?.maxlength">This
                          Field can be at most 200 characters</span>
                      </div>
                    </div>
                    <!-- Daily Bunker Consumption IFO/Ton -->
                    <div class="form-group">
                      <label for="txtIFOTon">Daily Bunker Consumption (IFO) in Ton</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <input type="text" formControlName="IFOTon" name="IFOTon" id="txtIFOTon" maxlength="4"
                        class="form-control" />
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTon?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTon?.errors?.required">This
                          Field is Required</span>
                      </div>
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTon?.invalid"
                        class="red">
                        <!-- <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTon?.errors?.pattern">This Field allows digits only</span> -->
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTon?.errors?.pattern">This
                          Field must be (1 to 2) digits and allows (1) Decimal</span>
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTon?.errors?.maxlength">This
                          Field can be at most 50 characters</span>
                      </div>
                    </div>
                    <!-- Daily Bunker Price IFO ($/ton) -->
                    <div class="form-group">
                      <label for="txtIFOTonPrice">Bunker Price (IFO) ($/ton)</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <input type="text" formControlName="IFOTonPrice" name="IFOTonPrice" id="txtIFOTonPrice"
                        class="form-control" />
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTonPrice?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTonPrice?.errors?.required">This
                          Field is Required</span>
                      </div>
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTonPrice?.invalid"
                        class="red">
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTonPrice?.errors?.pattern">This
                          Field must be (1 to 4) digits and allows (2) Decimal</span>
                        <!-- <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTonPrice?.errors?.pattern">This Field must be (1 to 2) digits and allows (1) Decimal</span> -->
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.IFOTonPrice?.errors?.maxlength">This
                          Field can be at most 200 characters</span>
                      </div>
                    </div>
                    <!-- Daily Bunker Consumption DO/Ton -->
                    <div class="form-group">
                      <label for="txtDOTon">Daily Bunker Consumption (DO) in Ton</label>

                      <input type="text" formControlName="DOTon" name="DOTon" id="txtDOTon" maxlength="4"
                        class="form-control" />
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTon?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTon?.errors?.required">This
                          Field is Required</span>
                      </div>
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTon?.invalid"
                        class="red">
                        <!-- <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTon?.errors?.pattern">This Field allows digits only</span> -->
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTon?.errors?.pattern">This
                          Field must be (1 to 2) digits and allows (1) Decimal</span>
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTon?.errors?.maxlength">This
                          Field can be at most 50 characters</span>
                      </div>
                    </div>
                    <!-- Daily Bunker Price DO ($/ton) -->
                    <div class="form-group">
                      <label for="txtDOTonPrice">Bunker Price (DO) ($/ton)</label>

                      <input type="text" formControlName="DOTonPrice" name="DOTonPrice" id="txtDOTonPrice"
                        class="form-control" />
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTonPrice?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTonPrice?.errors?.required">This
                          Field is Required</span>
                      </div>
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTonPrice?.invalid"
                        class="red">
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTonPrice?.errors?.pattern">This
                          Field must be (1 to 4) digits and allows (2) Decimal</span>
                        <!-- <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTonPrice?.errors?.pattern">This Field must be (1 to 2) digits and allows (1) Decimal</span> -->
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DOTonPrice?.errors?.maxlength">This
                          Field can be at most 200 characters</span>
                      </div>
                    </div>
                    <!-- Daily Time Charter -->
                    <div class="form-group">
                      <label for="txtDailyTimeCharter">Daily Time Charter ($)</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <input type="text" formControlName="DailyTimeCharter" name="DailyTimeCharter"
                        id="txtDailyTimeCharter" class="form-control" />
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DailyTimeCharter?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DailyTimeCharter?.errors?.required">This
                          Field is Required</span>
                      </div>
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DailyTimeCharter?.invalid"
                        class="red">
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DailyTimeCharter?.errors?.pattern">This
                          Field allows digits only</span>
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DailyTimeCharter?.errors?.maxlength">This
                          Field can be at most 200 characters</span>
                      </div>
                    </div>
                    <!-- SC Tolls -->
                    <div class="form-group">
                      <label for="txtSCTolls">SC Tolls ($)</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <input type="text" formControlName="SCTolls" name="SCTolls" id="txtSCTolls"
                        class="form-control" />
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.SCTolls?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.SCTolls?.errors?.required">This
                          Field is Required</span>
                      </div>
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.SCTolls?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.SCTolls?.errors?.pattern">SC
                          Tolls allows digits and (1 to 2) Decimals</span>
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.SCTolls?.errors?.maxlength">This
                          Field can be at most 200 characters</span>
                      </div>
                    </div>
                    <!-- SC Other Charges -->
                    <div class="form-group">
                      <label for="txtSCOtherCharges">Other SC Charges ($)</label>
                      <input type="text" formControlName="SCOtherCharges" name="SCOtherCharges" id="txtSCOtherCharges"
                        class="form-control" />
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.SCOtherCharges?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.SCOtherCharges?.errors?.pattern">Other
                          SC Charges allows digits and (1 to 2) Decimals</span>
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.SCOtherCharges?.errors?.maxlength">This
                          Field can be at most 200 characters</span>
                      </div>
                    </div>
                    <!-- Panama Tolls -->
                    <div class="form-group">
                      <label for="txtPanamaTolls">Panama Tolls ($)</label>
                      <!-- <span *ngIf="formMode != 3" class="red"> *</span> -->
                      <input type="text" formControlName="PanamaTolls" name="PanamaTolls" id="txtPanamaTolls"
                        class="form-control" />
                      <!-- <div *ngIf="isOptionSubmitted && rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.PanamaTolls?.invalid" class="red">
                                                <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.PanamaTolls?.errors?.required">This Field is Required</span>
                                            </div> -->
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.PanamaTolls?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.PanamaTolls?.errors?.pattern">Panama
                          Tolls allows digits and (1 to 2) Decimals</span>
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.PanamaTolls?.errors?.maxlength">This
                          Field can be at most 200 characters</span>
                      </div>
                    </div>
                    <!-- Panama Other Charges -->
                    <div class="form-group">
                      <label for="txtPanamaOtherCharges">Other Panama Charges ($)</label>
                      <input type="text" formControlName="PanamaOtherCharges" name="PanamaOtherCharges"
                        id="txtPanamaOtherCharges" class="form-control" />
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.PanamaOtherCharges?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.PanamaOtherCharges?.errors?.pattern">Other
                          Panama Charges allows digits and (1 to 2) Decimals</span>
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.PanamaOtherCharges?.errors?.maxlength">This
                          Field can be at most 200 characters</span>
                      </div>
                    </div>
                    <!-- Cargo intake Suez (Ton) -->
                    <div class="form-group">
                      <label for="txtCargoSuezTon">Cargo intake via Suez (Ton)</label>
                      <!-- <span *ngIf="formMode != 3" class="red"> *</span> -->
                      <input type="text" formControlName="CargoSuezTon" name="CargoSuezTon" id="txtCargoSuezTon"
                        class="form-control" />
                      <!-- <div *ngIf="isOptionSubmitted && rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.CargoSuezTon?.invalid" class="red">
                                                <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.CargoSuezTon?.errors?.required">This Field is Required</span>
                                            </div> -->
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.CargoSuezTon?.invalid"
                        class="red">
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.CargoSuezTon?.errors?.pattern">This
                          Field allows digits only</span>
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.CargoSuezTon?.errors?.maxlength">This
                          Field can be at most 50 characters</span>
                      </div>
                    </div>
                    <!-- Cargo intake Cape (Ton) -->
                    <div class="form-group">
                      <label for="txtCargoPanamaTon">Cargo intake via Cape (Ton)</label>
                      <!-- <span *ngIf="formMode != 3" class="red"> *</span> -->
                      <input type="text" formControlName="CargoPanamaTon" name="CargoPanamaTon" id="txtCargoPanamaTon"
                        class="form-control" />
                      <!-- <div *ngIf="isOptionSubmitted && rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.CargoPanamaTon?.invalid" class="red">
                                                <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.CargoPanamaTon?.errors?.required">This Field is Required</span>
                                            </div> -->
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.CargoPanamaTon?.invalid"
                        class="red">
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.CargoPanamaTon?.errors?.pattern">This
                          Field allows digits only</span>
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.CargoPanamaTon?.errors?.maxlength">This
                          Field can be at most 50 characters</span>
                      </div>
                    </div>
                    <!-- Freight per Ton ($) -->
                    <div class="form-group">
                      <label for="txtFreightPerTon">Freight per Ton ($)</label>
                      <!-- <span *ngIf="formMode != 3" class="red"> *</span> -->
                      <input type="text" formControlName="FreightPerTon" name="FreightPerTon" id="txtFreightPerTon"
                        class="form-control" />
                      <!-- <div *ngIf="isOptionSubmitted && rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.FreightPerTon?.invalid" class="red">
                                                <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.FreightPerTon?.errors?.required">This Field is Required</span>
                                            </div> -->
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.FreightPerTon?.invalid"
                        class="red">
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.FreightPerTon?.errors?.pattern">This
                          Field allows digits only</span>
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.FreightPerTon?.errors?.maxlength">This
                          Field can be at most 200 characters</span>
                      </div>
                    </div>
                    <!-- Cargo Lost Value ($) -->
                    <div class="form-group">
                      <label for="txtCargoLostValue">Cargo Lost Value ($)</label>
                      <!-- <span *ngIf="formMode != 3" class="red"> *</span> -->
                      <input type="text" formControlName="CargoLostValue" name="CargoLostValue" id="txtCargoLostValue"
                        class="form-control" />
                      <!-- <div *ngIf="isOptionSubmitted && rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.CargoLostValue?.invalid" class="red">
                                                <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.CargoLostValue?.errors?.required">This Field is Required</span>
                                            </div> -->
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.CargoLostValue?.invalid"
                        class="red">
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.CargoLostValue?.errors?.pattern">This
                          Field allows digits only</span>
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.CargoLostValue?.errors?.maxlength">This
                          Field can be at most 200 characters</span>
                      </div>
                    </div>
                    <!-- Total Cost Suez ($) -->
                    <div class="form-group">
                      <label for="txtTotalCostSuez">Total Cost via Suez ($)</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <input type="text" formControlName="TotalCostSuez" name="TotalCostSuez" id="txtTotalCostSuez"
                        class="form-control" />
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.TotalCostSuez?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.TotalCostSuez?.errors?.required">This
                          Field is Required</span>
                      </div>
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.TotalCostSuez?.invalid"
                        class="red">
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.TotalCostSuez?.errors?.pattern">This
                          Field allows digits only</span>
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.TotalCostSuez?.errors?.maxlength">This
                          Field can be at most 200 characters</span>
                      </div>
                    </div>
                    <!-- Total Cost Cape/Panama ($) -->
                    <div class="form-group">
                      <label for="txtTotalCostPanama">Total Cost via Cape or Panama ($)</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <input type="text" formControlName="TotalCostPanama" name="TotalCostPanama"
                        id="txtTotalCostPanama" class="form-control" />
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.TotalCostPanama?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.TotalCostPanama?.errors?.required">This
                          Field is Required</span>
                      </div>
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.TotalCostPanama?.invalid"
                        class="red">
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.TotalCostPanama?.errors?.pattern">This
                          Field allows digits only</span>
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.TotalCostPanama?.errors?.maxlength">This
                          Field can be at most 200 characters</span>
                      </div>
                    </div>
                    <!-- Diff. in Cost ($) -->
                    <div class="form-group">
                      <label for="txtDiffInCost">Diff. in Cost ($)</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <input type="text" formControlName="DiffInCost" name="DiffInCost" id="txtDiffInCost"
                        class="form-control" />
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DiffInCost?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DiffInCost?.errors?.required">This
                          Field is Required</span>
                      </div>
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DiffInCost?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DiffInCost?.errors?.pattern">Diff.
                          in Cost allows digits and (1 to 2) Decimals</span>
                        <span
                          *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DiffInCost?.errors?.maxlength">This
                          Field can be at most 200 characters</span>
                      </div>
                    </div>
                    <!-- Suggested Rebate (%) -->
                    <div class="form-group">
                      <label for="txtSuggestedRebate">Suggested Rebate (%)</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <div class="input-group">
                        <input type="text" formControlName="SuggestedRebate" name="SuggestedRebate"
                          id="txtSuggestedRebate" class="form-control" />
                        <span class="input-group-addon">%</span>
                      </div>
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.SuggestedRebate?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.SuggestedRebate?.errors?.required">This
                          Field is Required</span>
                      </div>
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.SuggestedRebate?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.SuggestedRebate?.errors?.pattern">Suggested
                          Rebate must be a Valid Percentage</span>
                      </div>
                    </div>
                    <!-- Date of Sailing -->
                    <div class="form-group" *ngIf="isCloneComponent">
                      <label for="dpDateOfSailing">Date of Sailing</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <input #dateOfSailingDatepicker="bsDatepicker" bsDatepicker formControlName="DateOfSailing"
                        [bsConfig]="{dateInputFormat: 'DD-MM-YYYY', minMode: hour}" [minDate]='mm' autocomplete="off"
                        id="dpDateOfSailing" class="form-control" name="DateOfSailing"
                        (ngModelChange)="dateOfSailingChange()">
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DateOfSailing?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DateOfSailing?.errors?.required">This
                          Field is Required</span>
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DateOfSailing?.errors?.inValidDateError">
                          {{'FRONT_USER.DATE_ERROR' | translate}}

                        </span>
                      </div>
                      <div *ngIf="isDateOfSailingGTETA" class="red">
                        <span>Date of Sailing shouldn't be after Estimated Time of Arrival (ETA)</span>
                      </div>
                    </div>
                    <div class="form-group" *ngIf="!isCloneComponent">
                      <label for="dpDateOfSailing">Date of Sailing</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <input #dateOfSailingDatepicker="bsDatepicker" bsDatepicker formControlName="DateOfSailing"
                        [bsConfig]="{dateInputFormat: 'DD-MM-YYYY', minMode: hour}" [minDate]='dateOfSailing'
                        autocomplete="off" id="dpDateOfSailing" class="form-control" name="DateOfSailing"
                        (ngModelChange)="dateOfSailingChange()">
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DateOfSailing?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DateOfSailing?.errors?.required">This
                          Field is Required</span>
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.DateOfSailing?.errors?.inValidDateError">
                          {{'FRONT_USER.DATE_ERROR' | translate}}

                        </span>
                      </div>
                      <div *ngIf="isDateOfSailingGTETA" class="red">
                        <span>Date of Sailing shouldn't be after Estimated Time of Arrival (ETA)</span>
                      </div>

                    </div>

                    <!-- ETA -->
                    <div class="form-group">
                      <label for="dpETA">Estimated Time of Arrival (ETA)</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <input #ETADatepicker="bsDatepicker" bsDatepicker formControlName="ETA"
                        [bsConfig]="{dateInputFormat: 'DD-MM-YYYY', minMode: hour}" autocomplete="off" id="dpETA"
                        class="form-control" name="ETA" (ngModelChange)="dateOfSailingChange()">
                      <div *ngIf="isOptionSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.ETA?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.ETA?.errors?.required">This
                          Field is Required</span>
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.ETA?.errors?.SeventyThreeDaysRoleError">
                          ETA can't be after 73 days

                        </span>

                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Options']?.controls[i]?.controls?.ETA?.errors?.inValidDateError">
                          {{'FRONT_USER.DATE_ERROR' | translate}}

                        </span>

                      </div>
                      <div *ngIf="isETASCGTETAD" class="red">
                        <span>ETA Suez Canal shouldn't be after ETA Destination port</span>
                      </div>
                    </div>

                    <!--<div class="form-group">
                                            <label for="RebateNotes">Notes</label>
                                            <textarea  name="RebateNote" id="RebateNote" formControlName="ETA" class="form-control"></textarea>
                                        </div>-->
                  </div>
                  <!-- Bunkering Ports Section -->
                  <!-- <div class="form-section">
                                        <h4 class="section-title">Bunkering Ports</h4>
                                    </div> -->
                </div>
                <!-- Add New Voyage -->
                <div *ngIf="(rebateRequestOptionsArrLength - noOfOptionsToBeDeletedGlobal) == 1"
                  class="bs-callout bs-callout-info" style="margin: 15px;">
                  <h4>Please Note</h4>
                  <p>You must add at least One Voyage</p>
                </div>
                <p *ngIf="!isOptionEdited && formMode != 3" class="btns-holder">
                  <button type="button" class="btn SCAcustomBtn" (click)="addNewVoyage()">Save Voyage</button>
                </p>
                <p *ngIf="isOptionEdited" class="btns-holder">
                  <!-- Save -->
                  <button type="button" class="btn SCAcustomBtn" (click)="saveEditedVoyage()">Save</button>
                  <!-- Cancel -->
                  <button type="button" class="btn SCAcustomBtn" (click)="cancelEditVoyage()">Cancel</button>
                </p>
              </div>
            </div>
            <!-- Principal Section -->
            <div>
              <div #tabTwoPrincipal>
                <div class="form-container">
                  <div class="form-section">
                    <h4 class="section-title">Principal</h4>
                    <!-- Name -->
                    <div class="form-group">
                      <label for="txtName">Name</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <input type="email" formControlName="Name" name="Name" id="txtName"
                        class="form-control text-uppercase" />
                      <div *ngIf="isTabTwoSubmitted && rebateRequestForm?.controls['TabTwo']?.controls['Name']?.invalid"
                        class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Name']?.errors?.required">This
                          Field is Required</span>
                      </div>
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Name']?.invalid" class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Name']?.errors?.pattern">Please
                          Enter a Valid Name</span>
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Name']?.errors?.maxlength">This
                          Field can be at most 200 characters</span>
                      </div>
                    </div>
                    <!-- Email -->
                    <div class="form-group">
                      <label for="txtEMail">Email</label>
                      <span *ngIf="formMode != 3" class="red"> *</span>
                      <input type="text" formControlName="EMail" name="EMail" id="txtEMail" class="form-control" />
                      <div *ngIf="isTabTwoSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['EMail']?.invalid" class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['EMail']?.errors?.required">This
                          Field is Required</span>
                      </div>
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['EMail']?.invalid" class="red">
                        <!-- <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['EMail']?.errors?.email">Please Enter a Valid Email Format</span> -->
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['EMail']?.errors?.pattern">Please
                          Enter a Valid Email Format</span>
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['EMail']?.errors?.maxlength">This
                          Field can be at most 50 characters</span>
                      </div>
                    </div>
                    <!-- Fax -->
                    <div class="form-group">
                      <label for="txtFax">Fax</label>
                      <!-- <span *ngIf="formMode != 3" class="red"> *</span> -->
                      <input type="text" formControlName="Fax" name="Fax" id="txtFax" class="form-control" />
                      <!-- <div *ngIf="isTabTwoSubmitted && rebateRequestForm?.controls['TabTwo']?.controls['Fax']?.invalid" class="red">
                                                <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Fax']?.errors?.required">This Field is Required</span>
                                            </div> -->
                      <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Fax']?.invalid" class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['Fax']?.errors?.pattern">Please
                          Enter a Valid Fax Number</span>
                      </div>
                    </div>
                    <!-- Terms & Conditions -->
                    <div
                      *ngIf="formMode == 1 || (formMode == 2 && !editModeAdmin) || isCloneComponent || (formMode == 2 && isRequestDetailsComponent)"
                      class="form-group">
                      <label for="chkTermsConditions">Terms & Conditions</label>
                      <span class="red"> *</span>
                      <div class="custom-checkbox">
                        <input type="checkbox" formControlName="TermsConditions" name="TermsConditions"
                          id="chkTermsConditions" [checked]="TermsConditions">
                        <label for="chkTermsConditions">
                          <a (click)="goToTermsAndConditions()" target="_blank">I accept terms &
                            Conditions</a>
                        </label>
                      </div>
                      <div *ngIf="isTabTwoSubmitted &&
                        rebateRequestForm?.controls['TabTwo']?.controls['TermsConditions']?.invalid" class="red">
                        <span *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['TermsConditions']?.errors?.pattern">You
                          should accept Service Terms & Conditions to use this Service</span>
                      </div>
                    </div>
                    <!-- reCaptcha -->
                    <!-- <div *ngIf="formMode == 1 || (formMode == 2 && !editModeAdmin)" id="divRecaptcha" class="form-group">
                                            <label for="reCaptcha">Captcha</label>
                                            <span class="red"> *</span>
                                            <ngx-recaptcha2 #reCaptcha formControlName="recaptcha" [siteKey]="sitekey" useGlobalDomain="false"></ngx-recaptcha2>
                                            <div *ngIf="isTabTwoSubmitted && rebateRequestForm?.controls['TabTwo']?.controls['recaptcha']?.invalid" class="red ">
                                                <div *ngIf="rebateRequestForm?.controls['TabTwo']?.controls['recaptcha']?.errors?.required">
                                                    <span>Captcha is Required</span>
                                                </div>
                                            </div>
                                        </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Previous -->
          <p *ngIf="formMode != 3" class="btns-holder text-right">
            <button type="button" class="btn SCAcustomBtn" (click)="selectTab(1)">Previous</button>
          </p>
        </tab>
      </tabset>
      <div class="form-group">
        <button
          *ngIf="(((isTabOneValid && formMode == 1) || formMode == 2) && !editModeAdmin) || isCloneComponent || (formMode == 2 && isRequestDetailsComponent)"
          type="button" class="btn SCAcustomBtn" (click)="submit()">Submit</button>
      </div>
    </form>
  </div>
</div>
<!-- Confirmation - Submit New Request -->
<div *ngIf="isFormValid && submitConfirmationMode == 1" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>{{confirmationMessage}}</p>
    <p *ngIf="formMode == 1 || isCloneComponent">Request Number [{{submitRebateRequestResponseObject.Data}}]</p>
    <p>Go Back to <a routerLink="/NavigationRequests">My Requests</a></p>
  </div>
</div>
<!-- Error -->
<div *ngIf="isFormValid && submitConfirmationMode == 2" class="alert alert-danger" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>
    <p>Something went wrong, Please <a (click)="reloadComponent()">try again</a></p>
    <hr>
    <p>Go to <a href="/English/Pages/ContactUs.aspx">Contact Us</a></p>
  </div>
</div>
<app-messaging *ngIf="!isFormValid"></app-messaging>
